import type { IWatermarkElement } from '@/types/watermarks.types';
import styles from '../watermark.module.css';

const TextEl = (el: IWatermarkElement) => {
  const { font, font_size, color, value } = el.settings.text;

  return (
    <div
      style={{
        userSelect: 'none',
        fontFamily: font?.name ? `'${font.name}'` : undefined,
        fontSize: font_size,
        color: color + 'bf', // 75% opacity fill
        WebkitTextStroke: '1px #0000003f', // 25% opacity black stroke
        fontStyle: font?.style ?? 'normal',
        fontWeight: font?.weight ?? 'normal',
        letterSpacing: font?.letterSpacing ?? 'normal',
        textTransform: font?.caps ? 'uppercase' : 'none',
        whiteSpace: 'nowrap',
      }}
      className={el.settings.duration === 'pulse' ? styles.pulse : ''}
    >
      {value}
    </div>
  );
};

export default TextEl;
